import { SET_SATSER, SatserActionTypes } from './Types';
import { Satser } from '../../Utilities/SatserApi';

const initialState: Satser | null = null;

export function satserReducer(state: Satser | null = initialState, action: SatserActionTypes): Satser | null {
    switch (action.type) {
        case SET_SATSER: {
            return action.payload;
        }
        default:
            return state;
    }
}
